module.exports = {
  "nav.BRAND": "Apollon Advice",
  "nav.NEW": "New",
  "nav.IMPORT": "Import",
  "nav.CASES": "Cases",
  "nav.ANALYSE": "Analysis",
  "nav.EXPORT": "Exporter",
  "nav.BATCH": "Batch",
  "nav.ACTION": "Actions",
  "nav.ADMIN": "Admin",
  "nav.LOGOUT": "Logout",
  "nav.CUSTOMER": "Customer",
  "nav.CLOSE_CASES": "Close cases",
  "nav.INSURER_MANAGEMENT": "Products en risk carries",
  "nav.USER_MANAGEMENT": "Users",
  "nav.CONFIGURATION_MANAGEMENT": "Screen configuration",
  "nav.TRANSFORMATION_FILES": "Transformation files",
  "nav.BUSINESS_RULES": "Define Business Rules",
  "nav.BASE_TABLES": "Base tables",
  "nav.PDF_TEMPLATES": "Pdf Template",
  "nav.PDF_TEMPLATES_FILES": "Pdf template files",
  "SUBBRANCHE_DESCRIPTION": "Description",
  "ACCEPT_MANUALLY": "Accept manually",
  "RECALCULATE_TITLE": "Recalculate before accepting",
  "RECALCULATE_MESSAGE": "Because changes have been made to the policy, a recalculation is necessary before the policy can be accepted.",
  "ACCEPT_MANUALLY_MESSAGE": "Please provide a reason for accepting this policy manually",
  "NoClaimsDiscountTable": "No Claim table",
  "COVER": "Coverage",
  "COVERS": "Coverages",
  "CALCULATE": "Calculate",
  "RECALCULATE": "Recalculate",
  "REOPEN": "Change",
  "NOT_AUTHORIZED_TO_EDIT": "You don't have permission to change this case.",
  "RESPONSES": "Result",
  "REQUEST_SUMMARY": "Request",
  "SELECT": "Select",
  "SELECTED": "Selected",
  "SELECTED_POLICY": "Selected policy",
  "ACCEPT": "Accept",
  "CONFIRM_CLOSE_MESSAGE": "Are you sure this policy needs to be cancelled?",
  "NOT_FOUND": "Not found",
  "CUSTOMER": "Customer",
  "UNIQUE_ID": "Unique ID",
  "LAST_EDIT_USER": "Last edited by",
  "LAST_EDIT_TIME": "Last edit",
  "PREVIEW": "Preview",
  "HIDE_PREVIEW": "Hide preview",
  "SHOW_ONLY_PREMIUMS": "Show premiums only",
  "SHOW_FULL_INFO": "Show full info",
  "SHOW_ALL": "Show all",
  "MODIFY_SELECTED": "Modify selected",
  "CANCEL_SELECTION": "Cancel selection",
  "No_Claims_Discount": "No Claims Discount",
  "SAVE_AND_ACCEPT": "Save and accept",
  "msg.FORM_NOT_RENDERED_YET": "The form cannot be sent because it has nog been fully rendered.",
  "msg.LIST_CASES_EMPTY": "No cases found.",
  "No_Of_Policies": "Number of policies",
  "Package_Discounts": "Package discount",
  "ADD_NEW_STEP": "Add new step",
  "ADD_NEW_LINE": "Add line",
  "Category": "Category",
  "API_VALUE_INCOMING": "API value(incoming)",
  "API_VALUE_OUTGOING": "API value(outgoing)",
  "department": "Afdeling",
  "ID": "ID",
  "POLICY_ID": "Policy ID",
  "RELATION_ID": "Relation ID",
  "RELATION": "Relation",
  "CURRENT": "Current",
  "TOP_2": "Top 2",
  "SEARCH": "Search",
  "SEARCH_CASES": "ID, Policy ID of Relation ID",
  "CASES": "\"Items\"",
  "DATE": "Date",
  "NEXT_PAGE": "Next",
  "PREV_PAGE": "Previous",
  "CLOSE_CASE": "Cancelled",
  "CLOSE_CASE2": "Cancel case",
  "SUMMARY": "Summary",
  "TO_TOP": "To top",
  "ALL_BATCHES": "All batch names",
  "ALL_PRODUCT_LINES": "All products",
  "ALL_POLICY_CASE_STATUSES": "All case statuses",
  "STATUS": "Status",
  "NET": "Net",
  "DAYS": "days",
  "VALIDATIONS": "Validation",
  "REASON": "Reason",
  "NET_PREMIUM": "Net premium",
  "REQUESTED_SUMMARY_LABEL": "Current premium",
  "RESPONSE_SUMMARIES_LABEL": "New premiums",
  "EQUAL": "Equal",
  "NOT_AVAILABLE": "n/a",
  "SHOW_VALIDATIONS": "Show validations",
  "LOCK_CASE": "Not locked",
  "UNLOCK_CASE": "Locked",
  "closeReason.REASON_1": "Continue existing policy",
  "closeReason.REASON_2": "Cancel current policy, customer does not want a new policy",
  "closeReason.REASON_3": "Cancel current policy, customer applies for new policy and does not accept proposal",
  "closeReason.REASON_4": "Cancel current policy, customer retains existing policy, manual transaction",
  "settings.TITLE": "Paston Apollon Advice - Application and Version information",
  "settings.SUMMARY": "This is the Apollon Advice Application from Paston Solutions B.V. This application has been created for insurancebrokers. With this application, you can manage your customer, policy and claims administration and use cases and tasks to compare your current policies and make the right offer to your customers.",
  "settings.VERSION_SUMMARY": "The Paston Apollon Advice Application is custom configurable and consists of several components, each with its own version number:",
  "settings.VERSION_TABLE_CAPTION": "Version information",
  "settings.VERSION_TABLE_HEADER_MODULE": "Module",
  "settings.VERSION_TABLE_HEADER_VERSION": "Version",
  "settings.DEFAULT_PAGE": "Standard start screen",
  "settings.SALES_CHANNELS": "Sales channels",
  "version.LABEL_WEB": "Userinterface",
  "version.LABEL_MODEL": "Datamodel",
  "version.LABEL_RULES": "Business Rules",
  "version.LABEL_CASES": "Case module",
  "version.LABEL_ADMIN": "Admin module",
  "version.LABEL_CHARTS": "Report model",
  "msg.ERROR_GETTING_VERSIONS": "An error occurred while retrieving part of the version information.",
  "status.OPEN": "Open",
  "status.NOT_ADVISED": "Failure",
  "status.ADVISED": "Advised",
  "status.ACCEPTED": "Accepted",
  "status.ACCEPTED_MANUALLY": "Accepted manually ",
  "status.ARCHIVED": "Archived",
  "status.CLOSED": "Closed",
  "status.HISTORICAL": "History",
  "status.REOPENED": "Reopened",
  "status.NOT_CALCULATED": "Not calculated",
  "action.IMPORT_CUSTOMERS": "Import customers",
  "action.IMPORT_POLICIES": "Import policies",
  "action.IMPORT_COVERS": "Importer covers",
  "action.EXPORT": "Export",
  "action.RECALC": "Recalculate",
  "action.RECALC_CASE_IDS": "Recalculate",
  "action.CLOSE": "Close",
  "action.CLOSE_CASE_IDS": "Close",
  "action.DELETE": "Delete",
  "action.DELETE_CUSTOMERS": "Delete",
  "action.DELETE_CASES": "Delete",
  "action.DELETE_CASE_IDS": "Delete",
  "action.IMPORT_NVGA2": "Import NVGA 2.0",
  "product.LIABILITY": "Personal Liability",
  "product.HOUSECONTENT": "Home Content",
  "product.HOUSEFIRE": "Home Property",
  "product.HOUSECOMBI": "Home Property & Home Content",
  "product.PASSENGERCAR": "Car",
  "product.TRAVEL": "Continuous travel",
  "product.LIABILITY_JSON": "Personal Liability - JSON",
  "product.HOUSECONTENT_JSON": "Home Content - JSON",
  "product.HOUSEFIRE_JSON": "Home Property - JSON",
  "product.HOUSECOMBI_JSON": "Home Property & Home Content - JSON",
  "product.PASSENGERCAR_JSON": "Car - JSON",
  "product.TRAVEL_JSON": "Doorlopende reis - JSON",
  "product.LIABILITY_NEW": "Personal Liability - New",
  "product.HOUSECONTENT_NEW": "Home Content - New",
  "product.HOUSEFIRE_NEW": "Home Property - New",
  "product.HOUSECOMBI_NEW": "Home Property & Home Content - New",
  "product.PASSENGERCAR_NEW": "Car - New",
  "product.TRAVEL_NEW": "Continuous travel - New",
  "insurer.UNKNOWN": "-",
  "insurer.AEGON": "Aegon",
  "insurer.AIG": "Unknown",
  "insurer.ALLIANZ": "Allianz",
  "insurer.AMLIN": "AMLIN",
  "insurer.AON_TOPGEAR": "Aon ADPL a.s.r.",
  "insurer.ARAG": "Arag",
  "insurer.ASR": "a.s.r.",
  "insurer.ATOSI": "Unknown",
  "insurer.AVERO": "AvÃ©ro",
  "insurer.BOUWNED": "Unknown",
  "insurer.CEL": "Unknown",
  "insurer.DAS": "DAS",
  "insurer.DL": "Delta Lloyd",
  "insurer.ESSENT": "Unknown",
  "insurer.EUROPEESCHE": "Unknown",
  "insurer.GENERALI": "Generali",
  "insurer.GOUDSE": "De Goudse",
  "insurer.HDI": "Unknown",
  "insurer.HIENFELD": "W.A. Hienfeld",
  "insurer.HISCOX": "Hiscox",
  "insurer.INTERPOLIS": "Interpolis Schade",
  "insurer.KLAVERBLAD": "Klaverblad",
  "insurer.KAMPEN": "Van Kampen",
  "insurer.KUIPER": "Kuiper Assuradeuren",
  "insurer.LIPPMANN": "Unknown",
  "insurer.LONDON": "London",
  "insurer.MEEUS": "Unknown",
  "insurer.MIDGLAS": "Midglas",
  "insurer.NEDASCO": "Nedasco",
  "insurer.NN": "Nationale Nederlanden",
  "insurer.NOORDELINGE": "Noorderlinge",
  "insurer.NOORDHOLLANDSCHE": "Noordhollandsche van 1816",
  "insurer.OTHER": "Unknown",
  "insurer.PROVIDE": "Provide",
  "insurer.REAAL": "Reaal",
  "insurer.RISK": "Risk Assuradeuren",
  "insurer.SAMENWERKING": "Samenwerking Glasverzekering",
  "insurer.TURIEN": "Turien & Co",
  "insurer.UMG": "UMG",
  "insurer.UNIGARANT": "Unigarant",
  "insurer.UVM": "Unknown",
  "insurer.VEREENDE": "De Vereende",
  "insurer.VOOGD": "Voogd & Voogd",
  "insurer.VSP": "Vandien Service Provider",
  "insurer.VSS": "VVS Verzekeringen",
  "insurer.Wederkerige": "Wederkerige",
  "insurer.ZEEUWSE": "De Zeeuwse",
  "insurer.RHION": "Rhion",
  "insurer.DDU_NN": "Aon DDU NN (A2)",
  "insurer.IAK": "IAK Privé Pakket",
  "insurer.AON_ASR": "Aon DDU a.s.r. (A1)",
  "insurer.AON_DIRECT": "Aon Direct",
  "insurer.AON_WSM_ASR": "AON WSM a.s.r.",
  "insurer.AON_WSM_NN": "AON WSM Nationale Nederlanden",
  "insurer.NN_DDU": "AON DDU Nationale Nederlanden",
  "productLine.SUFFIX_DEFAULT": " - Cases",
  "productLine.SUFFIX_NEW": " - New",
  "term.MONTH": "month",
  "term.QUARTER": "quarter",
  "term.HALF_YEAR": "half-year",
  "term.YEAR": "year",
  "term.1": "month",
  "term.3": "quarter",
  "term.6": "half-year",
  "term.12": "year",
  "term.short.1": "m",
  "term.short.3": "q",
  "term.short.6": "hy",
  "term.short.12": "y",
  "term.short.MONTH": "m",
  "term.short.QUARTER": "q",
  "term.short.HALF_YEAR": "hy",
  "term.short.YEAR": "y",
  "cover.LIABILITY_MAIN": "Liability",
  "cover.LIABILITY_STAR": "Star cover",
  "cover.LIABILITY_HUNTER": "Hunting risk",
  "cover.LIABILITY_DIY": "DIY",
  "cover.LIABILITY_VESSEL": "Boats",
  "cover.LIABILITY_REDRESS": "Recovery risk",
  "cover.LIABILITY_RENTAL_UNITS": "Rented accommodation units",
  "cover.LIABILITY_LARGE_ANIMALS": "Large animals",
  "cover.short.LIABILITY_MAIN": "Liability",
  "cover.short.LIABILITY_STAR": "Star",
  "cover.short.LIABILITY_HUNTER": "Hunting",
  "cover.short.LIABILITY_DIY": "BIY",
  "cover.short.LIABILITY_VESSEL": "Boats",
  "cover.short.LIABILITY_REDRESS": "Recovery",
  "cover.short.LIABILITY_RENTAL_UNITS": "Rented units",
  "cover.short.LIABILITY_LARGE_ANIMALS": "Big animals",
  "ownrisk.LIABILITY_GENERIC": "Own risk default",
  "ownrisk.LIABILITY_CHILDREN": "Own risk children",
  "ownrisk.LIABILITY_ADDITIONAL": "Own risk additional",
  "insuredamount.LIABILITY_GENERIC": "Insured amount",
  "insuredamount.LIABILITY_CHILDREN": "Insured amount children",
  "cover.PASSENGERCAR_LIABILITY": "Liability",
  "cover.PASSENGERCAR_LIMITED": "Limited Hull",
  "cover.PASSENGERCAR_COMPREHENSIVE": "Hull",
  "cover.PASSENGERCAR_ROADSIDE_ASSISTANCE": "Roadside assistance",
  "cover.PASSENGERCAR_PASSENGER_DAMAGE": "Impairment insurance",
  "cover.PASSENGERCAR_LEGAL_ASSISTANCE": "Legal aid",
  "cover.PASSENGERCAR_REDRESS": "Recovery risk",
  "cover.PASSENGERCAR_ACCESSORIES": "Accessories",
  "cover.PASSENGERCAR_AUDIO_EQUIPMENT": "Audio",
  "cover.PASSENGERCAR_PASSENGER_ACCIDENT": "Accident occupants cover",
  "cover.PASSENGERCAR_BM_PROTECTION": "Bonus/Malus protection",
  "cover.PASSENGERCAR_FREE_BODY_SHOP": "Free choice of repair shop",
  "cover.PASSENGERCAR_TRAILER": "Trailer cover",
  "cover.short.PASSENGERCAR_LIABILITY": "WA",
  "cover.short.PASSENGERCAR_LIMITED": "BC",
  "cover.short.PASSENGERCAR_COMPREHENSIVE": "VC",
  "cover.short.PASSENGERCAR_ROADSIDE_ASSISTANCE": "Assist",
  "cover.short.PASSENGERCAR_PASSENGER_DAMAGE": "SVI",
  "cover.short.PASSENGERCAR_LEGAL_ASSISTANCE": "RB",
  "cover.short.PASSENGERCAR_REDRESS": "VRB",
  "cover.short.PASSENGERCAR_ACCESSORIES": "ACC",
  "cover.short.PASSENGERCAR_AUDIO_EQUIPMENT": "Audio",
  "cover.short.PASSENGERCAR_PASSENGER_ACCIDENT": "OVI",
  "cover.short.PASSENGERCAR_BM_PROTECTION": "BM Protect",
  "cover.short.PASSENGERCAR_FREE_BODY_SHOP": "Free.recovery.",
  "cover.short.PASSENGERCAR_TRAILER": "Trailer",
  "ownrisk.PASSENGERCAR_GENERIC": "Own risk standard",
  "ownrisk.PASSENGERCAR_ADDITIONAL": "Own risk voluntary",
  "ownrisk.PASSENGERCAR_FREE_BODY_SHOP": "Free choice of repair shop",
  "ownrisk.PASSENGERCAR_THEFT": "Theft",
  "insuredamount.PASSENGERCAR_PASSENGER_ACCIDENT_DEATH": "Insured amount accident/death",
  "insuredamount.PASSENGERCAR_PASSENGER_ACCIDENT_DISABLED": "Insured amount accident/disability",
  "insuredamount.PASSENGERCAR_AUDIO_EQUIPMENT": "Insured amount audio",
  "insuredamount.PASSENGERCAR_ACCESSORIES": "Insured amount accessories",
  "cover.HOUSECONTENT_BASIC": "UGV+ (Contents)",
  "cover.HOUSECONTENT_TOP": "AVBKO (Contents)",
  "cover.HOUSECONTENT_GLASS": "Glas (Contents)",
  "cover.HOUSECONTENT_JEWELRY": "Jewellery excluding theft",
  "cover.HOUSECONTENT_JEWELRY_WITH_THEFT": "Jewellery",
  "cover.HOUSECONTENT_MUSICAL_INSTRUMENTS": "Musical instruments",
  "cover.HOUSECONTENT_VALUABLES": "Valuables",
  "cover.HOUSECONTENT_INVENTORY": "Inventory",
  "cover.HOUSECONTENT_AUDIO": "Audiovisual equipment",
  "cover.HOUSECONTENT_OUTSIDE": "Outdoor valuables",
  "cover.HOUSECONTENT_COLLECTABLES": "Collections",
  "cover.HOUSECONTENT_ART": "Art",
  "cover.HOUSECONTENT_TENANT_INTEREST": "Renting interest",
  "cover.HOUSECONTENT_OTHER": "Special possessions",
  "cover.HOUSECONTENT_ELECTRONICS": "Electronics",
  "cover.HOUSECONTENT_RENTAL": "Rentals",
  "cover.HOUSECONTENT_SPORTS_EQUIPMENT": "Sports equipment",
  "cover.HOUSECONTENT_MOBILE_DEVICES": "Mobile phones/devices",
  "cover.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "Theft Mobile phones/devices",
  "cover.HOUSECONTENT_ANTIQUE": "Art/Antiquities",
  "cover.HOUSECONTENT_OWNER_INTEREST": "Owner interest",
  "cover.HOUSECONTENT_CYBER_SECURITY": "Cybersecurity",
  "cover.HOUSECONTENT_SPECIAL": "Special assets",
  "cover.short.HOUSECONTENT_BASIC": "UGV+",
  "cover.short.HOUSECONTENT_TOP": "AVBKO",
  "cover.short.HOUSECONTENT_GLASS": "Glass",
  "cover.short.HOUSECONTENT_JEWELRY": "Jew.excl.theft.",
  "cover.short.HOUSECONTENT_JEWELRY_WITH_THEFT": "Jewellery",
  "cover.short.HOUSECONTENT_MUSICAL_INSTRUMENTS": "Instruments",
  "cover.short.HOUSECONTENT_VALUABLES": "Val.",
  "cover.short.HOUSECONTENT_INVENTORY": "Invent.",
  "cover.short.HOUSECONTENT_AUDIO": "Audio",
  "cover.short.HOUSECONTENT_OUTSIDE": "Outside.",
  "cover.short.HOUSECONTENT_COLLECTABLES": "Collect.",
  "cover.short.HOUSECONTENT_ART": "Art",
  "cover.short.HOUSECONTENT_TENANT_INTEREST": "Rent.",
  "cover.short.HOUSECONTENT_OTHER": "Special",
  "cover.short.HOUSECONTENT_ELECTRONICS": "Electr.",
  "cover.short.HOUSECONTENT_RENTAL": "Rental",
  "cover.short.HOUSECONTENT_SPORTS_EQUIPMENT": "Sports.",
  "cover.short.HOUSECONTENT_MOBILE_DEVICES": "Mobile",
  "cover.short.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "Theft.mob.",
  "cover.short.HOUSECONTENT_ANTIQUE": "Art/Antiq.",
  "cover.short.HOUSECONTENT_OWNER_INTEREST": "Owner's interest",
  "cover.short.HOUSECONTENT_CYBER_SECURITY": "Cyber",
  "cover.short.HOUSECONTENT_SPECIAL": "Special",
  "ownrisk.HOUSECONTENT_GENERIC": "Own risk (Contents)",
  "ownrisk.HOUSECONTENT_ADDITIONAL": "Own risk additional",
  "insuredamount.HOUSECONTENT_GENERIC": "Insured amount (Contents)",
  "insuredamount.HOUSECONTENT_ANTIQUE": "Insured amount antiques",
  "insuredamount.HOUSECONTENT_ART": "Insured amount art",
  "insuredamount.HOUSECONTENT_AUDIO": "Insured amount audio",
  "insuredamount.HOUSECONTENT_COLLECTABLES": "Insured amount collections",
  "insuredamount.HOUSECONTENT_ELECTRONICS": "Insured amount electronics",
  "insuredamount.HOUSECONTENT_INVENTORY": "Insured amount inventory",
  "insuredamount.HOUSECONTENT_JEWELRY": "Insured amount personal jewellery",
  "insuredamount.HOUSECONTENT_MOBILE_DEVICES": "Insured amount mobile devices",
  "insuredamount.HOUSECONTENT_MOBILE_DEVICES_WITH_THEFT": "Insured amount mobile devices (with theft)",
  "insuredamount.HOUSECONTENT_MUSICAL_INSTRUMENTS": "Insured amount musical instruments",
  "insuredamount.HOUSECONTENT_OUTSIDE": "Insured amount outdoors",
  "insuredamount.HOUSECONTENT_OUTSIDE_JEWELRY": "Insured amount outdoor body jewellery",
  "insuredamount.HOUSECONTENT_OWNER_INTEREST": "Insured amount owner's interest",
  "insuredamount.HOUSECONTENT_RENTAL": "Insured amount rental",
  "insuredamount.HOUSECONTENT_SPECIAL": "Insured amount special assets",
  "insuredamount.HOUSECONTENT_SPORTS_EQUIPMENT": "Insured amoun sports equipment",
  "insuredamount.HOUSECONTENT_TENANT_INTEREST": "Insured amount tenant's interest",
  "insuredamount.HOUSECONTENT_VALUABLES": "Insured amount valuables",
  "cover.HOUSEFIRE_TOP": "AVBKO (Home Property)",
  "cover.HOUSEFIRE_BASIC": "UGV+ (Home Property)",
  "cover.HOUSEFIRE_GLASS": "Glas (Home Property)",
  "cover.HOUSEFIRE_RENTAL": "Rental (Home Property)",
  "cover.HOUSEFIRE_GARDEN": "Garden insurance (Home Property)",
  "cover.short.HOUSEFIRE_TOP": "AVBKO",
  "cover.short.HOUSEFIRE_BASIC": "UGV+",
  "cover.short.HOUSEFIRE_GLASS": "Glass",
  "cover.short.HOUSEFIRE_RENTAL": "Rental",
  "cover.short.HOUSEFIRE_GARDEN": "Garden",
  "ownrisk.HOUSEFIRE_GENERIC": "Own risk standard (Home Property)",
  "ownrisk.HOUSEFIRE_ADDITIONAL": "Own risk additional (Home Property)",
  "insuredamount.HOUSEFIRE_GENERIC": "Insured amount (Household)",
  "insuredamount.HOUSEFIRE_GARDEN": "Insured amount garden",
  "insuredamount.HOUSEFIRE_GLASS": "Insured amount glass",
  "cover.TRAVEL_MAIN": "Main coverage",
  "cover.TRAVEL_GENERIC": "Main coverage",
  "cover.TRAVEL_CANCELLATION": "Cancellation coverage",
  "cover.TRAVEL_LUGGAGE": "Luggage coverage",
  "cover.TRAVEL_AGENT": "Observer coverage",
  "cover.TRAVEL_MONEY": "Money coverage",
  "cover.TRAVEL_ACCIDENT": "Casualty coverage",
  "cover.TRAVEL_ROADSIDE_ASSISTANCE": "Roadside assistance coverage",
  "cover.TRAVEL_REDRESS": "Recovery coverage",
  "cover.TRAVEL_SPORTS": "Special sports coverage",
  "cover.TRAVEL_COMPOSED_JOURNEY": "Compound travel coverage",
  "cover.TRAVEL_SPORTGEAR": "Sports equipment coverage",
  "cover.TRAVEL_SKIING": "Ski-holiday coverage",
  "cover.TRAVEL_MEDICAL_EXPENSES": "Medical expense coverage",
  "cover.short.TRAVEL_MAIN": "Main",
  "cover.short.TRAVEL_GENERIC": "Main",
  "cover.short.TRAVEL_CANCELLATION": "Cancellation",
  "cover.short.TRAVEL_LUGGAGE": "Baggage",
  "cover.short.TRAVEL_AGENT": "Observer",
  "cover.short.TRAVEL_MONEY": "Money",
  "cover.short.TRAVEL_ACCIDENT": "Accident",
  "cover.short.TRAVEL_ROADSIDE_ASSISTANCE": "Roadside",
  "cover.short.TRAVEL_REDRESS": "Recovery",
  "cover.short.TRAVEL_SPORTS": "Sports",
  "cover.short.TRAVEL_COMPOSED_JOURNEY": "Together.",
  "cover.short.TRAVEL_SPORTGEAR": "Sports ext.",
  "cover.short.TRAVEL_SKIING": "Ski",
  "cover.short.TRAVEL_MEDICAL_EXPENSES": "Medical",
  "ownrisk.TRAVEL_MAIN": "Own risk",
  "ownrisk.TRAVEL_GENERIC": "Own risk standard",
  "ownrisk.TRAVEL_SPORTGEAR": "Own risk sports equipment ",
  "ownrisk.TRAVEL_LUGGAGE": "Own risk luggage ",
  "insuredamount.TRAVEL_CANCELLATION": "Insured amount cancellation",
  "insuredamount.TRAVEL_LUGGAGE": "Insured amount luggage ",
  "combiCover.HOUSECONTENT_TOP": "AVBKO (Home Contents)",
  "combiCover.HOUSECONTENT_BASIC": "UGV+ (Home Contents)",
  "combiCover.HOUSEFIRE_TOP": "AVBKO (Home Property)",
  "combiCover.HOUSEFIRE_BASIC": "UGV+ (Home Property)",
  "combiCover.HOUSECONTENT_GLASS": "Glas (Home Contents)",
  "combiCover.HOUSEFIRE_GLASS": "Glass (Home Property)",
  "combiOwnrisk.HOUSECONTENT_GENERIC": "Own risk standard (Home Contents)",
  "combiOwnrisk.HOUSEFIRE_GENERIC": "Own risk standard (Home Property)",
  "combiInsuredamount.HOUSECONTENT_GENERIC": "Insured amount (Home Contents)",
  "combiInsuredamount.HOUSEFIRE_GENERIC": "Insured amount (Home Property)",
  "auto.depreciationScheme": "DepreciationScheme",
  "auto.depreciationScheme.STANDARD": "Standard",
  "auto.depreciationScheme.PURCHASED_VALUE": "Purchase value",
  "auto.depreciationScheme.CURRENT_NEW_VALUE": "New value",
  "travel.maxTravelDuration": "Maximale Reistijd",
  "auto.depreciationScheme.standard": "Standard",
  "auto.depreciationScheme.purchasedValue": "Purchase value",
  "auto.depreciationScheme.currentNewValue": "New value",
  "msg.ERROR_LOADING_SUMMARY": "An error occurred while retrieving summary.",
  "msg.ERROR_LOADING_DETAILS": "An error occurred while retrieving details.",
  "msg.ERROR_DURING_OPERATION": "An error occurred while processing.",
  "msg.ERROR_DUPLICATE_RECORD": "A record with the same identifier already exists. Please use a unique identifier.;",
  "msg.ERROR_DUPLICATE_RECORD_STEP": "It is not allowed to enter multiple identical steps.",
  "msg.ERROR_DUPLICATE_RECORD_LINE": "It is not allowed to enter multiple identical lines.",
  "PRODUCT_LINE": "Product",
  "DOWNLOAD_TEMPLATE": "Download template",
  "UPLOAD_FILE": "Upload file",
  "SUBMIT": "Submit",
  "NAME": "Name",
  "FIRST_NAME": "First name",
  "LAST_NAME": "Surname and suffix",
  "USERNAME": "Username",
  "EMAIL": "E-mail",
  "ROLES": "Rolls",
  "EDIT": "Edit",
  "TYPE": "Type",
  "COMPLETED": "Ready",
  "ERRORS": "Errors",
  "WARNINGS": "Warnings",
  "REPORT": "Report",
  "DELETE": "Delete",
  "CLOSE": "Close",
  "DOWNLOAD": "Download",
  "TOTAL_ROWS": "Total number",
  "CASE": "Case",
  "MESSAGE": "Message",
  "BATCH_ID": "Batch name",
  "POLICY_CASE_STATUS": "Case status",
  "EXECUTE": "Execute",
  "COUNT": "Number",
  "BATCH": "Batch",
  "BATCHES": "Batches",
  "ITEMS": "Items",
  "DISABLED": "Unavailable",
  "ALL": "All",
  "CREATION_DATE": "Creation date",
  "msg.CANT_UPLOAD_FILE": "Cannot upload file.",
  "DUPLICATE_CODE": "This code is already in use.",
  "CASE_IMPORT": "Case import",
  "IMPORT_CONSISTS_LINE": "Import consists of a line per",
  "POLICY": "Policy",
  "CUSTOMER_IMPORT": "Customer import",
  "UPLOAD_CASE_LIST": "Upload list of cases",
  "UPLOAD_CUSTOMER_LIST": "Upload list of customers",
  "ACTIVE_IMPORT_JOBS": "Active import jobs",
  "JOB": "Task",
  "PAUSE": "Paused",
  "START": "Start",
  "CANCEL": "Cancel",
  "LINE_NR": "Line no.",
  "JOBS": "Tasks",
  "STARTDATE": "Starting date",
  "JOB_TYPE": "Task type",
  "SEE_HISTORY_OVERVIEW": "Show history overview",
  "SEE_HISTORY": "Show history",
  "HISTORY_OVERVIEW": "History overview",
  "USER_LAST_MODIFIED": "User last modified",
  "DATE_LAST_MODIFIED": "Date last modified",
  "VERSION": "Version",
  "SERVER_ERROR": "Server error",
  "msg.LIST_HISTORY_OVERVIEW_EMPTY": "No history cases were found.",
  "msg.ERROR_GETTING_JOB_DETAILS": "An error occurred while retrieving job details.",
  "msg.ERROR_STARTING_JOB": "An error occurred while starting the task.",
  "msg.ERROR_PAUSING_JOB": "An error occurred while pausing the task.",
  "msg.ERROR_CANCELING_JOB": "An error occurred while cancelling the task.",
  "msg.SURE_CANCEL_ACTION": "Are you sure you want to cancel this task?",
  "job.COMPLETE": "Ready",
  "job.RUNNING": "Active",
  "job.PAUSE_IN_PROGRESS": "Pausing",
  "job.PAUSED": "Paused",
  "job.VALIDATED": "Validated",
  "job.PENDING": "Pending",
  "job.CANCELED": "Cancelled",
  "job.": "EXPIRED=Expired",
  "job.FAILED": "Failure",
  "job.VALIDATION_FAILED": "Validation error",
  "action.RUNNING": "Running",
  "SELECT_ALL_FIELDS": "Select all mandatory fields.",
  "CLOSE_EXPORTED_CASES": "Close exported cases as well.",
  "TRANSFORMATION_OUTPUT_FILE": "Export file",
  "msg.SURE_DELETE_FILE": "Are you sure you want to delete this file?",
  "BATCH_MANAGEMENT": "Batch management",
  "POLICYCASE_BATCH_MANAGEMENT": "Case Batch Management",
  "CUSTOMER_BATCH_MANAGEMENT": "Customer Batch Management",
  "SEARCH_BATCHES": "Search by batch name",
  "SEE_ACTIONS_OVERVIEW": "Go to action summary",
  "CANCEL_QUEUED_ACTIONS": "Cancel queued actions",
  "GO_TO_JOB": "Go to task",
  "RECALCULATING": "Recalculating",
  "PENDING_RECALCULATION": "Recalculating in queue...",
  "CLOSING": "Close...",
  "PENDING_CLOSE": "Closing in queue...",
  "DELETING": "Deleting...",
  "PENDING_DELETE": "Deleting in queue...",
  "msg.FOLLOWING_STATUSES_CANNOT_RECALCULATE": "The following statuses cannot be recalculated: Closed, History.",
  "msg.FOLLOWING_STATUSES_CANNOT_CLOSE": "The following statuses cannot be closed: Closed, History, Reopened.",
  "msg.SURE_DELETE_BATCHES": "Are you sure you want to delete this batch?",
  "msg.UNRECOGNISED_BATCH_ACTION": "Unknown batch action",
  "msg.RECALC_ACTION_ADDED_QUEUE": "A 'Recalculate' action has been added to the queue.",
  "msg.CLOSE_ACTION_ADDED_QUEUE": "A 'Close' action has been added to the queue.",
  "msg.DELETE_ACTION_ADDED_QUEUE": "A 'Delete' action has been added to the queue.",
  "msg.DELETE_CUSTOMERS_ACTION_ADDED_QUEUE": "A 'Delete Customer' action has been added to the queue.",
  "msg.RECALC_ACTION_NOT_ADDED_QUEUE": "A 'Recalculate' action has not been added to the queue.",
  "msg.CLOSE_ACTION_NOT_ADDED_QUEUE": "Addition of 'Close' to queue not possible.",
  "msg.DELETE_ACTION_NOT_ADDED_QUEUE": "Addition of 'Delete' to queue not possible.",
  "msg.DELETE_CUSTOMERS_ACTION__NOT_ADDED_QUEUE": "Addition of 'Customer Delete' to queue not possible.",
  "msg.SOMETHING_WRONG_FETCH_ACTIONS": "Something went wrong when retrieving the list of actions.",
  "msg.SURE_CANCEL_PENDING_ACTIONS": "Are you sure you want to cancel all queued actions?",
  "msg.NETWORK_ERROR_BIG_FILE_IMPORT": "Network error. Please use a file size of less than 10 MB.",
  "NO_BATCHES_FOUND": "No batches found.",
  "UPLOAD_CASE_IDS_LIST": "Upload list of policynumbers.",
  "ACTIONS_OVERVIEW": "Action summary",
  "DATE_OF_ACTION": "Action date",
  "STATUSES_PER_PRODUCT_LINE": "Status per product",
  "AUTHOR": "Owner",
  "ACTION": "Action",
  "DOWNLOAD_FILE": "Download file",
  "DOWNLOAD_CASE": "Download pdf",
  "ACCEPTED_MANUALLY": "Accept manually",
  "SAVE_CASE": "Save case",
  "DELETE_FILE": "Delete file",
  "msg.LIST_ACTIONS_EMPTY": "No actions found.",
  "msg.MISSING_EXPORT_FILE": "File is no longer available.",
  "CLOSE_MULTIPLE_CASES": "Close multiple cases.",
  "FILE_CONTAINING_CASES": "\"File with case ids.\"",
  "CLOSE_ALL": "Close all",
  "msg.FOLLOWING_CASES_SKIPPED": "The following cases have been skipped:",
  "msg.CASES_CLOSED_SUCCESS": "The cases have been successfully closed.",
  "UPLOAD_CONFIGURATION_FILE": "Upload screen layout file",
  "OR_EDIT_DIRECTLY": "Or edit here:",
  "LOAD_DEFAULT": "Load default values",
  "STORE_CURRENT_AS_DEFAULT": "Current values as defaults",
  "GENERATE_TEMPLATE": "Generate import template",
  "SAVE_CHANGES": "Save changes",
  "msg.FIX_EDITOR_ERRORS": "Resolve errors first",
  "msg.CONFIGURATION_SAVED": "Screen layout saved successfully.",
  "msg.ERROR_SAVING_CONFIGURATION": "An error occurred while saving the screen layout.",
  "msg.LOADED_DEFAULT_CONFIGURATION": "Standard values loaded.",
  "msg.ERROR_LOADING_DEFAULT_CONFIGURATION": "An error occurred while loading the default configuration.",
  "msg.CURRENT_CONFIGURATIONS_SAVED_AS_DEFAULT": "This configuration was saved as the default configuration.",
  "msg.ERROR_STORING_CURRENT_CONFIGURATIONS_AS_DEFAULT": "The new default configuration could unfortunately not be saved, please contact the administrator.",
  "msg.ERROR_STORING_GENERATE_IMPORT_TEMPLATE": "The generation of import template failed , please contact the administrator.",
  "POLICYCASE_FORM_CONFIGURATION": "Case form configuration",
  "CUSTOMER_FORM_CONFIGURATION": "Customer form configuration",
  "msg.SURE_OVERWRITE_CONFIGURATION_UPLOAD": "Are you sure you you want to overwrite the current configuration?",
  "msg.SURE_OVERWRITE_CURRENT_CONFIGURATION": "This will overwrite the current configuration. Are you sure?",
  "msg.SURE_OVERWRITE_DEFAULT_CONFIGURATION": "This will overwrite the default configuration for this form. Are you sure?",
  "CUSTOMER_MANAGEMENT": "Customer management",
  "SEARCH_BY_NAME_OR_UNIQUE_ID": "Relation ID or Name",
  "SEARCH_BY_NAME_USERNAME_EMAIL": "Search by name, user name or e-mail address",
  "CRM_LINK": "CRM link",
  "msg.NO_CUSTOMERS_FOUND": "No customers found.",
  "msg.FOLLOWING_WARNINGS_OCCURRED": "The following warning has occurred:",
  "msg.CUSTOMERS_UPLOAD_SUCCESS": "The list of relations has been successfully uploaded.",
  "ENABLE_PRODUCT_LINE": "Enable product",
  "DISABLE_PRODUCT_LINE": "Disable product",
  "UPLOAD_TRANSFORMATION_FILE": "Upload transformation file",
  "msg.TRANSFORMATION_FILE_UPLOAD_SUCCESS": "Transformation files have been saved successfully.",
  "msg.MISSING_TRANSFORMATION_FILE": "Incomplete transformation file for product:",
  "UPLOAD_PDF_TEMPLATE_FILE": "Upload PDF Template file",
  "msg.PDF_TEMPLATE_FILE_UPLOAD_SUCCESS": "PDF Template files have been saved successfully.",
  "msg.MISSING_PDF_TEMPLATE_FILE": "Incomplete PDF Template file for product:",
  "USER_MANAGEMENT": "User management",
  "ADD_NEW_USER": "Add new user",
  "CREATE_USER": "Create user",
  "EDIT_USER": "Modify user",
  "NO_USERS_FOUND": "No users found.",
  "ADD_USER": "Add user",
  "EDIT_ROLES_USER": "Modify roles for user",
  "AVAILABLE_ROLES": "Available roles",
  "GRANTED_ROLES": "Assigned roles",
  "msg.SURE_DELETE_USER": "Are you sure you want to delete this user?",
  "msg.UNABLE_LOAD_USER_ROLES": "Unable to retrieve user roles.",
  "msg.ROLE_GRANTED": "Role has been assigned to user:",
  "msg.ROLE_REMOVED": "Role has been removed for user:",
  "msg.ADDING_NEW_USER": "Add new user:",
  "msg.USER_CREATED": "User has been created.",
  "msg.EDIT_USER": "Modify user:",
  "msg.USER_CHANGES_SAVED": "Changes for the user have been saved.",
  "msg.DELETE_USER": "Deleting user:",
  "msg.USER_DELETED": "User has been deleted.",
  "msg.INVALID_EMAIL_ADDRESS": "Invalid email address",
  "SELECT_EXCEL_FILE": "Select Excel File",
  "API_TO_AFD_MAPPING": "API To AFD MAPPING",
  "ADD_API_MAPPING": "ADD API MAPPING",
  "AUDIT_OVERVIEW": "Audit message overview",
  "REQUESTED_POLICY": "Requested policy",
  "SEE_MESSAGES": "See messages",
  "FILES": "Files",
  "LAST_MODIFIED": "Last modified",
  "CREATED": "Created",
  "ADD_RULE": "Add business rule",
  "RESET_KIE_CONTAINER": "Refresh business rules",
  "SELECT_FILE": "Select a file from the list",
  "FILENAME": "File name",
  "ALLOWED_SYMBOLS": "Only letters, numbers and hyphens allowed.",
  "CHECK_VALIDATION_ERRORS": "Rectify incorrect entries.",
  "INPUT_VALIDATION_ERROR": "Expected format:",
  "SAVE": "Save",
  "SAVING": "Saving...",
  "ENABLED": "Available",
  "WHEN": "IF",
  "THEN": "THEN",
  "ADD": "Add",
  "ADD_CONDITION_IN_RULE": "Add a condition to the business line",
  "msg.SURE_UNSAVED_CHANGES_IN_RULE": "There are unsaved changes. Are you sure you want to continue?",
  "msg.SUCCESSFULLY_REMOVED_FILE": "File has deleted successfully.",
  "msg.REMOVED_SUCCESSFULLY": "Successfully deleted.",
  "msg.SAVED_SUCCESSFULLY": "Successfully saved.",
  "msg.SURE_DROOLS_RESET": "After refreshing the business rules, the next import, recalculation or preview will reload the business rules. This may cause a noticeable delay.",
  "msg.DROOLS_RESET_SUCCESS": "Business rules have been refreshed.",
  "msg.DROOLS_RESET_CREATED": "Business rules have been created successfully.",
  "RULES_GIT_SETTINGS_TITLE": "Git settings",
  "RULES_GIT_URL": "Git URL",
  "RULES_GIT_BRANCH": "Git branch",
  "msg.BRANCH_CHANGE_SUCCESS": "Branch has been changed successfully.",
  "msg.ERROR_LOADING_GIT_CONFIGURATIONS": "Git configurations cannot be loaded.",
  "dialog.YES": "Yes",
  "dialog.NO": "No",
  "dialog.OK": "OK",
  "ACTIVE": "Active",
  "error.LOCK_CHANGE_FAILED": "Change of lock failed.",
  "error.FORM_INVALID_PLEASE_FILL": "Form cannot be submitted due to missing mandatory information. Please check the form for red-bordered fields.",
  "XSD_DESCRIPTION": "XSD Description",
  "SUIV_DESCRIPTION": "Description",
  "SUIV_NAME": "Name",
  "SUIV_PRODUCT": "VPI productId",
  "AL_VIEWCOD": "Viewcode",
  "_PPRC": "Commission percentage",
  "msg.GENERATE_TEMPLATE_MSG": "Generate import template will replace existing template if exists , are you sure?",
  "commissionAmount": "Commission Amount",
  "BACKOFFICE_CODE_INCOMING": "Backoffice code (incoming)",
  "BACKOFFICE_CODE_OUTGOING": "Backoffice code (outgoing)",
  "AFD_CODE": "afd code",
  "msg.GIM_UPLOAD_SUCCESS": "Gim object file had uploaded successfully",
  "GIM_OBJECT_NAME": "Gim object file name",
  "GIM_OBJECT_DESCRIPTION": "Gim object file",
  "gim_object": "GIM object",
  "GIMOBJECTID": "GimObject Id",
  "No_Claims_Discount_DESCRIPTION": "Description",
  "Step": "Step",
  "DiscountPercentage": "Discount percentage",
  "Verrijking": "Enrichment",
  "VEHICLE_INFORMATION": "Vehicle information",
  "BUILDING_INFORMATION": "Building information",
  "NONE": "None",
  "SubBranche": "Sub-branch",
  "DUPLICATE_PRODUCTLINE": "A branche with this subbranche already exists",
  "err.productline.not_found": "Branche '{0}' not found.",
  "err.policynumber.duplicate_found": "Duplicate IDs found in file: {0}.",
  "productCodeLevel": "Productcode Level",
  "commercialProduct": "Commercial product",
  "productCodeLevel_invalid": "Productcode Level must be a number between 1 and 9999.",
  "commercialProduct_invalid": "Commercial product must be a number between 1 and 99999."
}


//////////////////
// WEBPACK FOOTER
// ./src/language_en.properties
// module id = Bmsd
// module chunks = 1